import { API_ENDPOINTS } from "@/constants/api";

import type { PlanLimits } from "./plans.service";
export type { PlanLimits } from "./plans.service";

export interface SubscriptionPlan {
  id: string;
  name: string;
  description: string | null;
  billingInterval: string;
  price: number;
  currency: string;
  limits: PlanLimits;
  features: string[];
}

export interface CustomerSubscription {
  id: string;
  status: string;
  startDate: string;
  endDate: string | null;
  trialEndsAt: string | null;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  canceledAt: string | null;
  setupUrl?: string;
  plan: SubscriptionPlan;
}

export async function getSubscription(): Promise<CustomerSubscription | null> {
  const res = await fetch(API_ENDPOINTS.SUBSCRIPTION.CURRENT, {
    credentials: "include",
  });
  if (res.status === 404 || res.status === 204) return null;
  if (!res.ok) {
    throw new Error(`Failed to fetch subscription: ${res.status}`);
  }
  const body = await res.json();
  if (!body) return null;
  return body as CustomerSubscription;
}

export async function cancelSubscription(): Promise<void> {
  const res = await fetch(API_ENDPOINTS.SUBSCRIPTION.CANCEL, {
    method: "DELETE",
    credentials: "include",
  });
  if (res.status === 204 || res.ok) return;
  throw new Error(`Failed to cancel subscription: ${res.status}`);
}
